// const _ = require('lodash')

const Util = {
    /**
     * 精度相加
     * @param arg1
     * @param arg2
     * @returns {number}
     */
    accAdd(arg1,arg2){
        let r1,r2,m;
        try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
        try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
        m=Math.pow(10,Math.max(r1,r2));
        const { accMul } = Util
        return (accMul(arg1, m)+accMul(arg2, m))/m;
    },
    /**
     * 精度相乘
     * @param num1
     * @param num2
     * @returns {number}
     */
    accMul(num1, num2) {
        if (typeof(num1) === "undefined" || typeof(num2) === "undefined") {
            return 0
        }
        let m = 0
        const s1 = num1.toString()
        const s2 = num2.toString()
        try {
            const ss1 = s1.split('.')
            const ss2 = s2.split('.')
            if (ss1.length > 1) {
                m += ss1[1].length;
            }
            if (ss2.length > 1) {
                m += ss2[1].length;
            }
            // eslint-disable-next-line
            return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
        } catch (e) {
            console.log(e);
            return 0
        }
    },
    /**
     * 精度相除
     * @param arg1
     * @param arg2
     * @returns {number}
     */
    accDiv(arg1, arg2) {
        let t1 = 0, t2 = 0, r1, r2;
        try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
        try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
        with (Math) {
            r1 = Number(arg1.toString().replace(".", ""))
            r2 = Number(arg2.toString().replace(".", ""))
            return (r1 / r2) * pow(10, t2 - t1);
        }
    },
    fixedCore: {
        units: [
            {
                // 单位
                name: '',
                // 幂次方
                pow: 0,
                // 证书长度
                length: 1,
                // 进位限制
                limit: 0,
                // 进位单位名称
                nextName: '',
            },
            {
                name: '',
                pow: 0,
                length: 2,
                limit: 0,
                nextName: '',
            },
            {
                name: '',
                pow: 0,
                length: 3,
                limit: 0,
                nextName: '',
            },
            {
                name: '',
                pow: 0,
                length: 4,
                limit: 0,
                nextName: '',
            },
            {
                name: '万',
                pow: 4,
                length: 5,
                limit: 1000,
                nextName: '千万',
            },
            {
                name: '万',
                pow: 4,
                length: 6,
                limit: 1000,
                nextName: '千万',
            },
            {
                name: '万',
                pow: 4,
                length: 7,
                limit: 1000,
                nextName: '千万',
            },
            {
                name: '千万',
                pow: 7,
                length: 8,
                limit: 10,
                nextName: '亿',
            },
            {
                name: '亿',
                pow: 8,
                length: 9,
                limit: 0,
                nextName: '',
            },
        ],
        // 保留两位小数
        core (n, len=2) {
            len = isNaN(len) ? 0 : len
            n = isNaN(n) ? 0 : Math.abs(n)
            const num = Math.pow(10, len)
            // 2019/8/13 14:42 改为向下取整
            return Util.accDiv(Math.floor(Util.accMul(n, num)), num)
        },
        // 补零
        stringZero (handleNumber=0, len = 2) {
            const floatNum = (handleNumber + '').split('.')[1]
            const floatLength = floatNum ? floatNum.length : 0
            // 小数补0
            if (floatNum) {
                for (let i = 0; i < len - floatLength; i++) {
                    handleNumber += '0'
                }
            }
            return handleNumber
        },
        // 进位
        numberCarry (num=0, unit) {
            const { units, core } = Util.fixedCore
            // 获取单位对象
            const { limit, nextName } = units.find(un => un.name === unit)
            if (limit !== 0 && nextName !== '') {
                if (num === limit) {
                    num = core(Util.accDiv(num, limit))
                    unit = nextName
                }
            }
            return {
                num,
                unit
            }
        },
        // 单位转换
        unitTransform (n=0, len=2, ifFormatter=false, needSource=false) {
            n = Math.abs(n)
            const { core, stringZero, units, numberCarry } = Util.fixedCore
            // 获取整数位长度
            const intLength = (n + '').split('.')[0].length
            // 整数位是否大于9位
            let { name, pow } = units.find(unit => unit.length === (intLength > 9 ? 9 : intLength))
            let result = core(Util.accDiv(n, 10 ** pow), len)
            // 进位检验
            const { num, unit } = numberCarry(result, name)
            name = unit
            result = num
            if (ifFormatter) {
                result = result.toLocaleString()
            }
            result = stringZero(result, len)
            if (needSource) {
                return `${result}<i class='money-unit'>${name}</i>`
            } else {
                return `${result}${name}`
            }
        },
        // formatter 数字 ,
        formatterNumber (num=0, ifFormatter = false) {
            if (typeof num !== "number") {
                num = parseFloat(num)
            }
            if (ifFormatter) {
                num = num.toLocaleString()
            }
            return num
        }
    },
    /**
     *专门处理小数保留
     * @param n
     * @param len
     * @param ifRow {boolean} 是否*100 default:需要*100
     * @param ifUnitTransform {boolean} 是否格式化单位
     * @param ifFormatter {boolean} 是否格式化数字,
     * @return {string}
     */
    toFixedForPer (n=0, len=2, ifRow=true, ifUnitTransform=true, ifFormatter=false, needSource=false) {
        n = Math.abs(n)
        if (ifRow) {
            n = Util.accMul(n, 100)
        }

        const { stringZero, unitTransform, core, formatterNumber } = Util.fixedCore;
        let handleNumber;
        if (ifUnitTransform) {
            handleNumber = unitTransform(n, len, ifFormatter, needSource);
        } else {
            handleNumber = core(n, len);
            // formatter 过滤
            handleNumber = formatterNumber(handleNumber, ifFormatter)
        }
        handleNumber = stringZero(handleNumber, len)
        return n === 0 ? '0.00' : handleNumber
    },

    toFixed(n=0, len=2, ifFormatter=false) {
        n = Math.abs(n)
        const { stringZero, core } = Util.fixedCore
        let result = core(n, len)
        if (ifFormatter) {
            result = stringZero(result.toLocaleString(), len)
        }
        return result
    },
    toFixedForUnit(n=0, len=2, ifFormatter=false, needSource=false) {
        const { unitTransform } = Util.fixedCore
        return unitTransform(...arguments)
    },

    /**
     * 取整十数（522 => 530）
     * @param num
     */
    ceilNum(num) {
        return Math.ceil(num / 10) * 10
    },

    /**
     * 用于曲线图y轴最大值，包括向上取整
     */
    getMax(list, key, isPercent = false) {
        const arr = list || []
        const newArr = arr.map(v => isPercent ? Util.accMul(v[key], 100) : v[key])
        if (newArr.length > 0) {
            return Util.ceilNum(Math.max(...newArr))
        } else {
            return 0
        }
    }
}

module.exports = Util
